module.exports = "//public.zight.com/packs/media/images/close-a3c03d36f634f39ab13f1253444428d5.svg";